<template>
  <div class="index_right">
    <el-popover placement="left" ref="subPopoverRef">
      <div>
        <div class="index_content">
          <div style="display: flex; width: 100%" v-on:click="closeList">
            <img
              style="
                width: 20px;
                height: 20px;
                margin-top: 16px;
                margin-left: 358px;
              "
              src="../assets/images/sindex/sindex_x.png"
            />
          </div>

          <div class="index_content_title">入园咨询登记</div>
          <div class="index_content_subtitle">问题留言，我们会尽快联系您</div>
          <img
            style="padding-top: 16px"
            src="../assets/images/sindex/consult_line.png"
          />

          <!-- 入园登记列表 start -->
          <div style="padding-top: 20px" v-show="fromVisible">
            <div>
              <el-form
                label-position="top"
                label-width="80px"
                :rules="rules"
                ref="ruleForm"
                :model="ruleForm"
                style="width: 316px"
              >
                <el-form-item label="企业名称（非必填）" prop="name">
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="请输入企业名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="person">
                  <el-input
                    v-model="ruleForm.person"
                    placeholder="请输入联系人姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="职位" prop="work">
                  <el-input
                    v-model="ruleForm.work"
                    placeholder="请输入职位"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="phone">
                  <el-input
                    v-model="ruleForm.phone"
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>
                <el-form-item label="咨询内容" prop="desc">
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="ruleForm.desc"
                    placeholder="税收政策/招商政策/灵活用工/入园流程等"
                    show-word-limit
                    maxlength="500"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <el-button class="commit_btn" @click="commit('ruleForm')"
              >提交</el-button
            >
          </div>
          <!-- 入园登记列表 end -->

          <!-- 入园登记列表完成 start -->
          <div
            class="index_content_su"
            v-show="!fromVisible"
            style="
              width: 100%;
              display: flex;
              align-items: center;
              flex-direction: column;
              position: relative;
            "
          >
            <div
              style="left: 40px; top: 10px; position: absolute"
              v-on:click="back"
            >
              返回
            </div>
            <img
              style="padding-top: 80px; width: 86px; height: 87px"
              src="../assets/images/sindex/commit_su.png"
            />
            <div class="index_content_su_text">提交成功，我们会尽快联系您</div>
            <div class="index_content_sc_bottom">
              <div class="index_content_sc_bottom_text">或主动联系我们</div>
              <div class="index_content_sc_bottom_text">
                联系电话：0898-67209184
              </div>
              <div class="index_content_sc_bottom_text">
                工作时间：周一至周五 09:00-18:00
              </div>
              <div class="index_content_sc_bottom_text">
                咨询地址：海南生态软件园沃克公园8848
              </div>
            </div>
          </div>
          <!-- 入园登记列表完成 end -->
        </div>
      </div>

      <!-- 入园咨询 start -->
      <div slot="reference" class="index_right_consult">
        <img
          style="padding-top: 17px; height: 20px; width: 20px"
          src="../assets/images/sindex/consult@2x.png"
        />
        <div class="index_right_consult_text">入园咨询</div>
      </div>
      <!-- 入园咨询 end -->
    </el-popover>

    <!-- 置顶 start -->
    <div class="index_right_top">
      <a href="#">
        <img src="../assets/images/sindex/to_top.png" />
      </a>
    </div>
    <!-- 置顶 end -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      fromVisible: true,

      ruleForm: {
        name: '',
        person: '',
        work: '',
        phone: '',
        desc: '',
      },
      rules: {
        name: [{ required: false, message: '' }],
        person: [{ required: true, message: '联系人不能为空' }],
        work: [{ required: true, message: '职位不能为空' }],
        phone: [{ required: true, message: '联系电话不能为空' }],
        desc: [{ required: true, message: '咨询内容不能为空' }],
      },
    }
  },

  methods: {
    back: function () {
      this.fromVisible = true
    },
    showTab() {
      if(this.$refs.subPopoverRef) {
        this.$refs.subPopoverRef.showPopper = true
      }
    },
    commit: function (ruleForm) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.advisoryAdd()
        } else {
          console.log('error submit!!')

          return false
        }
      })
    },
    closeList: function () {
      if(this.$refs.subPopoverRef) {
        this.$refs.subPopoverRef.showPopper = false
      }
    },
    advisoryAdd: function () {
      let that = this
      that
        .$axios({
          method: 'post',
          url: that.api + '/bootdo/advisory/add',
          params: {
            advisoryContent: that.ruleForm.desc,
            contactPerson: that.ruleForm.person,
            contactPhone: that.ruleForm.phone,
            enterpriseName: that.ruleForm.name,
            workPosition: that.ruleForm.work,
          },
        })
        .then(function (msg) {
          if (msg.data.code == 100) {
            that.fromVisible = false
          } else {
            // that.getError(msg.data);
          }
        })
    },
  },
}
</script>

<style scoped>
.index_right {
  height: 206px;
  width: 54px;
  position: fixed;
  bottom: 100px;
  z-index: 999;
  right: 21px;
}
.index_right_consult {
  width: 54px;
  height: 132px;
  background: linear-gradient(180deg, #6997ff 0%, #165dff 100%);
  border-radius: 27px;
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
}
.index_right_consult_text {
  width: 16px;
  height: 80px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 20px;
}
.index_right_top {
  padding-top: 20px;
  width: 54px;
  height: 54px;
}

.index_content {
  width: 380px;
  height: 665px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.index_content_title {
  margin-top: -10px;
  width: 144px;
  height: 33px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #0052d9;
  line-height: 33px;
}
.index_content_subtitle {
  padding-top: 4px;
  width: 182px;
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4e5969;
  line-height: 22px;
}
.commit_btn {
  width: 316px;
  height: 40px;
  background: #165dff;
  border: none;
  border-radius: 4px;
  color: #ffffff;
}
.index_content_su_text {
  width: 208px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 22px;
}
.index_content_sc_bottom {
  margin-top: 148px;
  width: 316px;
  height: 176px;
  background: #f7f8fa;
  border-radius: 8px;
}
.index_content_sc_bottom_text {
  margin-left: 20px;
  margin-top: 16px;
  width: 258px;
  height: 22px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4e5969;
  line-height: 22px;
}
/deep/ .el-form-item label {
  line-height: 22px;
  padding: 0 0 8px;
}
/deep/ .el-form-item content {
  height: 180px;
}
/deep/ .el-textarea {
  line-height: 10px;
}
</style>
